/**
 * Shows a numerical input to adjust the index of the stat in the array.
 * @param {Object} doc the document
 * @param {String} groupName the name of the group the stat is in
 * @param {Object} stat the stat object we're editing
 * @param {Number} startingIndex the original index of the stat  
 * @param {Function} sendMessage the sendMessage method that allows us to call socket server API methods
 */
export default function SetStatIndex(props) {
    // let doc = props.doc;
    let stat = props.stat;
    let groupName = props.groupName;
    let startingIndex = props.startingIndex;
    const setIndex = (e) => {
        let statName = e.target.dataset.statname;
        let newIndex = e.target.dataset.newindex;
        let oldIndex = e.target.dataset.oldindex;
        // console.log(statName, oldIndex, newIndex);
        let statid = e.target.dataset.statid;
        props.sendMessage({
            operation: 'set stat index',
            statName,
            statGroup: groupName,
            statid,
            newIndex: newIndex,
            oldIndex: oldIndex,
        });
    }
    if(!stat.editable) return (
        <td></td>
    );
    let max = props.doc[groupName].length - 1;
    console.log(max)
    let prevIndex = Math.max(0, startingIndex - 1);
    let nextIndex = Math.min(max, startingIndex + 1);
    return(
        <td>
            <button
                onClick={setIndex}
                data-oldindex={startingIndex}
                data-newindex={prevIndex}
                data-statname={stat.name}
                data-statid={stat._id}
                disabled={prevIndex === startingIndex}
                >⯅</button>
            <button
                onClick={setIndex}
                data-oldindex={startingIndex}
                data-newindex={nextIndex}
                data-statname={stat.name}
                data-statid={stat._id}
                disabled={nextIndex === startingIndex}
            >⯆</button>
        </td>
    )
}